'use client';
import { getIconByKey, IconToken } from '@1debit/icons';
import { PropsWithChildrenAndClass } from 'types/sharedComponents';
import { cn } from 'utils/styles';
import { useFAQArrowTracking } from 'components/analytics/hooks';
import { useAnalyticsModuleTracking } from 'components/analytics/AnalyticsModuleTracking';
import { trackAccordionClicked, trackFaqArrowClicked } from 'components/analytics/eventHandlerTracking';

interface Props extends PropsWithChildrenAndClass {
  openIcon?: IconToken;
  closeIcon?: IconToken;
  isActive?: boolean;
  label?: string;
  onClick?: (opened: boolean) => void;
}
export const Summary = ({
  children,
  className,
  isActive,
  openIcon = 'add',
  closeIcon = 'remove',
  label,
  onClick,
  ...rest
}: Props) => {
  const Open = getIconByKey(openIcon);
  const Close = getIconByKey(closeIcon);
  const faqTracking = useFAQArrowTracking({ faq_question: label || '' });
  const { attributes } = useAnalyticsModuleTracking();
  const isFaq = attributes.moduleType.toLowerCase() === 'faq';

  return (
    <summary
      className={cn(`font-sans font-medium list-none flex justify-between items-center gap-3`, className)}
      {...rest}
      onClick={e => {
        e.preventDefault();

        const willBeActive = !isActive;

        // Trigger state update first to unblock UI rendering
        onClick?.(willBeActive);

        // Defer analytics to yield back to the browser, reducing INP processing duration
        if (willBeActive) {
          setTimeout(() => {
            if (isFaq) {
              faqTracking();
              trackFaqArrowClicked({
                faq_question: label || '',
              });
            } else {
              trackAccordionClicked({
                label: label || '',
              });
            }
          }, 0);
        }
      }}>
      {children}
      <span>
        <Open className="group-open:hidden" />
        <Close className="hidden group-open:inline-block" />
      </span>
    </summary>
  );
};

export default Summary;
